import { FC } from 'react'

import CustomerCaseStudyBox from '@/components/CustomerCaseStudyBox'

const quote = `For us to be a frontrunner in sustainable logistics, we needed a solid foundation to build on. You can't lead on shaky ground. With Lune's reliable emission visibility, we've transformed sustainability into a commercial differentiator.`

const FortoCaseStudyBox: FC<{ quoted?: boolean }> = ({ quoted = false }) => {
    return (
        <CustomerCaseStudyBox
            reference={'/customers/forto'}
            sx={{
                backgroundColor: '#0A143C',
            }}
            chipLabels={[`Emissions intelligence`, `Vessel tracking`, `API`]}
            subText={quoted ? `“${quote}”` : quote}
            mainText={`How Forto built a sustainable competitive advantage using emissions intelligence`}
            avatar={{
                title: 'Christian Volp',
                subtitle: `Senior Sustainability Manager at Forto`,
            }}
            counterBox={{
                adoption: `60% of customers taking climate action`,
                usageFallback: `3+ million shipments`,
            }}
            images={{
                avatar: {
                    source: `/images/forto-case-study/customer-quote-1-avatar.png`,
                    altText: 'Christian Volp',
                },
                desktop: {
                    source: '/images/forto-case-study/case-study-box-desktop.png',
                    altText: 'Container ship',
                },
                mobile: {
                    source: `url('/images/forto-case-study/case-study-box-mobile.png')`,
                },
            }}
        />
    )
}

export default FortoCaseStudyBox
